import { useCallback, useEffect, useRef } from 'react';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function useAppActive(timeout) {
    const [is_app_active, noActive, isActive] = useBooleanState(false);
    const timerRef = useRef();
    const clearTimer = useCallback(() => {
        const timerId = timerRef.current;
        if (timerId) {
            timerRef.current = undefined;
            clearTimeout(timerId);
        }
    }, []);
    const onActive = useCallback(() => {
        clearTimer();
        isActive();
    }, []);
    const isNotActive = useCallback(() => {
        if (timeout != null) {
            timerRef.current = setTimeout(noActive, timeout);
        }
    }, []);
    useEffect(() => {
        isActive();
        document.addEventListener('pause', isNotActive);
        document.addEventListener('resume', onActive);
        return () => {
            clearTimer();
            document.removeEventListener('pause', isNotActive);
            document.removeEventListener('resume', onActive);
        };
    }, []);
    return is_app_active;
}
